import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'
import { toast } from 'react-toastify'
import { getUrlApi, getToken, setStorage } from './utils'

export function createHttp(version: string = 'v1', location?: string): AxiosInstance {
  return axios.create({
    baseURL: getUrlApi(location, version),
  })
}

export const HTTPv1: AxiosInstance = createHttp('v1')
export const HTTPv2: AxiosInstance = createHttp('v2')

export class Service {
  httpClient: AxiosInstance
  constructor(httpClient: AxiosInstance = HTTPv1) {
    this.httpClient = httpClient
  }
}

const getErrorFromResponse = (errors: unknown) => {
  try {
    if (!errors) return ''

    return Array.isArray(errors) ? errors : (Object.values(errors)[0] as any)[0]
  } catch {
    return ''
  }
}

function addInterceptors(httpInstance: any) {
  httpInstance.interceptors.request.use(
    (config: AxiosRequestConfig) => {
      const TOKEN = getToken()
      config.headers = config.headers ?? {}

      if (TOKEN) {
        config.headers.Authorization = `Bearer ${TOKEN}`
      } else {
        delete config.headers.Authorization
      }

      return config
    },
    (error: any) => Promise.reject(error),
  )

  httpInstance.interceptors.response.use(
    (response: AxiosResponse) => {
      return response
    },
    (error: any) => {
      const defaultMessage = 'Erro na requisição, tente novamente.'

      if (!error.response) {
        throw new Error(defaultMessage)
      }

      const { status } = error.response
      const message = getErrorFromResponse(error.response?.data?.errors)

      if (status) {
        if (status === 401) {
          localStorage.clear()
          setStorage('disconnect', 'true')
          window.location.href = '/login'
        }
        if (status === 403) {
          toast.warning('Não há permissão para esta tela.')
          setTimeout(() => {
            window.location.href = '/home'
          }, 1000)
        }
        throw new Error(message || defaultMessage)
      }

      return Promise.reject(error)
    },
  )
}

addInterceptors(HTTPv1)
addInterceptors(HTTPv2)
